import { authTypes, userTypes } from '../types';

const initialState = {
  access: localStorage.getItem('access') || null,
  access_expiration: localStorage.getItem('access_expiration') || null,
  refresh: localStorage.getItem('refresh') || null,
  refresh_expiration: localStorage.getItem('refresh_expiration') || null,
  isAuthenticated: localStorage.getItem('isAuthenticated') === 'true' || false,
  needToConfirmEmail: localStorage.getItem('needToConfirmEmail') === 'true' || false,
  user: JSON.parse(localStorage.getItem('user') || 'null'),
  chatToken: localStorage.getItem('chatToken') || null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case authTypes.REGISTER_EMAIL:
      return action.payload;
    case authTypes.COFIRM_EMAIL:
      return action.payload;
    case authTypes.LOG_IN:
      return action.payload;
    case authTypes.LOG_OUT:
      return null;
    case authTypes.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case authTypes.REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        ...action.payload,
      };
    case userTypes.GET_ONE:
    case userTypes.SET_USER:
    case userTypes.UPDATE_ONE:
      return {
        ...state,
        user: action.payload,
      };
    default:
      return state;
  }
}

export default authReducer;
